import React, { useState } from "react";
import { auth } from "../fire";
import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";

export default function Home() {
  const [user, setUser] = useState({});
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [noMatchError, setNoMatchError] = useState("");
  const [Confirmpassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();

  const login = async () => {
    try {
      const user = await signInWithEmailAndPassword(auth, email, password);
      console.log(user);
      if (user) {
        navigate("/coinbase");
      }
    } catch (error) {
      console.log(error.message);
      setEmailError(error.message);
    }
  };

  const register = async () => {
    console.log("weeeeeeeeerrw");
    try {
      const user = await createUserWithEmailAndPassword(auth, email, password);
      console.log(user);
      if (user) {
        navigate("/");
      } else {
        setNoMatchError("Password does not Match");
      }
    } catch (error) {
      console.log(error.message);
      setEmailError(error.message);
      console.log(error.message);
    }
  };

  return (
    <div className="homePageLogin">
      <div className="loginDiv">
        <h1>Login to your account to continue</h1>
        <input
          type="text"
          placeholder="Email address"
          className="emailInput"
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <p className="errorsg">{emailError}</p>
        <input
          type="password"
          placeholder="password"
          className="emailInput"
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
        <p className="errorsg">{emailError}</p>

        <button className="login_registerbtn" onClick={register}>
          Register
        </button>

        <p className="haveaAnAccount">
          Already have an account?{" "}
          <Link to="/" className="loginHere">
            Login here{" "}
          </Link>
        </p>
      </div>
    </div>
  );
}
